// src/store/formReset/types.js
export const RESET_FORM_FIELDS = 'RESET_FORM_FIELDS';